<div class="series-audit-statistics">
  @if (!seriesStatistics && loadingStatistics) {
    Loading...
  }
  @if (!seriesStatistics && !loadingStatistics) {
    No sub hourly statistic for this hour and series.
  }
  @if (seriesStatistics) {
    <div class="row center space-between">
      <div class="info-item">
        <label>Total points</label>
        <div class="value">{{seriesStatistics['total_points']}}</div>
      </div>
      <div class="info-item">
        <label>First value</label>
        <div class="value">{{seriesStatistics['first_value']}}</div>
      </div>
      <div class="info-item">
        <label>First timestamp</label>
        <div class="value">{{seriesStatistics['first_timestamp'] | stringDate}}</div>
      </div>
      <div class="info-item">
        <label>Uploaded by</label>
        <div class="value">{{seriesStatistics['first_upload_by']}}</div>
      </div>
      <div class="info-item">
        <label>Last value</label>
        <div class="value">{{seriesStatistics['last_value']}}</div>
      </div>
      <div class="info-item">
        <label>Last timestamp</label>
        <div class="value">{{seriesStatistics['last_timestamp'] | stringDate}}</div>
      </div>
      <div class="info-item">
        <label>Uploaded by</label>
        <div class="value">{{seriesStatistics['last_upload_by']}}</div>
      </div>
    </div>
    <h3>User statistics</h3>
    @for (userStat of seriesStatistics['user_stats']; track userStat) {
      <div class="row center space-between stats-row">
        <div class="info-item">
          <label>User</label>
          <div class="value">{{userStat['user']}}</div>
        </div>
        <div class="info-item">
          <label>Percentage</label>
          <div class="value">{{userStat['percentage']}}</div>
        </div>
      </div>
    }
  }
</div>
